<template>
  <div class="text-xs-center">
    <v-btn
      small
      fab
      outline
      :disabled="index == 0 || !showForward"
      @click="$emit('onMove', 'top')"
      color="primary"
      class="my-1 mx-0"
    >
      <span class="fas fa-angle-double-left"></span>
    </v-btn>
    <v-btn
      small
      fab
      outline
      :disabled="index <= 0"
      @click="$emit('onMove', 'up')"
      color="primary"
      class="my-1 mx-0"
    >
      <span class="fas fa-angle-left"></span>
    </v-btn>
    <v-btn
      small
      fab
      outline
      :disabled="index >= lastIndex"
      @click="$emit('onMove', 'down')"
      color="primary"
      class="my-1 mx-0"
    >
      <span class="fas fa-angle-right"></span>
    </v-btn>
    <v-btn
      small
      fab
      outline
      :disabled="index == lastIndex || !showForward"
      @click="$emit('onMove', 'bottom')"
      color="primary"
      class="my-1 mx-0"
    >
      <span class="fas fa-angle-double-right"></span>
    </v-btn>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['index', 'max', 'showForward'],
  computed: {
    lastIndex: function () {
      return this.max - 1
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/MoveVertical2.vue